import { createAsyncTypes } from 'utils/ActionCreator'

import { PLAN_TYPES } from 'containers/App/constants'

const typeKey = 'Partner/EditTenantModal'

export const FETCH_TENANT_DATA = createAsyncTypes('FETCH_TENANT_DATA', typeKey)
export const EDIT_TENANT_APPLY_ASYNC = createAsyncTypes('EDIT_TENANT_APPLY_ASYNC', typeKey)

export const CHANGE_SILENT_MODE_STATUS = `${typeKey}/CHANGE_SILENT_MODE_STATUS`
export const CHANGE_TRIAL_PLAN = `${typeKey}/CHANGE_TRIAL_PLAN`
export const CHANGE_TRIAL_EXPIRATION = `${typeKey}/CHANGE_TRIAL_EXPIRATION`
export const CHANGE_PLAN = `${typeKey}/CHANGE_PLAN`
export const CHANGE_PLAN_TOGGLE_VALUES = `${typeKey}/CHANGE_PLAN_TOGGLE_VALUES`
export const CHANGE_MAILBOX_LIMIT = `${typeKey}/CHANGE_MAILBOX_LIMIT`
export const CHANGE_EXPIRATION_DATE = `${typeKey}/CHANGE_EXPIRATION_DATE`
export const CHANGE_ALLOWED_DOMAINS = `${typeKey}/CHANGE_ALLOWED_DOMAINS`
export const CHANGE_ENFORCE_MAILBOXES_LIMIT = `${typeKey}/CHANGE_ENFORCE_MAILBOXES_LIMIT`
export const CHANGE_DMARC_FOR_PARTNERS = `${typeKey}/CHANGE_DMARC_FOR_PARTNERS`
export const TOGGLE_ADDON = `${typeKey}/TOGGLE_ADDON`
export const TOGGLE_AUTOPILOT = `${typeKey}/TOGGLE_AUTOPILOT`
export const CHANGE_CANCELLATION_REASON = `${typeKey}/CHANGE_CANCELLATION_REASON`
export const CHANGE_CANCELLATION_COMMENT = `${typeKey}/CHANGE_CANCELLATION_COMMENT`
export const CHANGE_AUTO_CONVERT_TRIAL = `${typeKey}/CHANGE_AUTO_CONVERT_TRIAL`

export const EDIT_TENANT_TABS_OPTIONS = {
  PLANS: 1,
  ACCOUNT_SETTINGS: 2,
}

export const SILENT_MODE_OPTIONS = [
  { value: true, label: 'On' },
  { value: false, label: 'Off' },
]

export const PLAN_OPTIONS = [
  { value: PLAN_TYPES.CAMPAIGNS_ONLY, label: 'Simulation & Training' },
  { value: PLAN_TYPES.SAT_SUITE, label: 'Human Risk Management' },
  { value: PLAN_TYPES.CORE, label: 'Essential Protect (Core)' },
  { value: PLAN_TYPES.IRONSCALES_PROTECT, label: 'IRONSCALES Protect' },
  { value: PLAN_TYPES.EMAIL_ESSENTIALS, label: 'Email Essentials' },
  { value: PLAN_TYPES.EMAIL_PROTECT, label: 'Email Protect' },
  { value: PLAN_TYPES.EMAIL_PROTECT_VAR, label: 'Email Protect' },
  { value: PLAN_TYPES.EMAIL_PROTECT_PRO, label: 'Email Protect Pro' },
  { value: PLAN_TYPES.COMPLETE_PROTECT, label: 'Complete Protect' },
]

export const PLAN_TRIAL_OPTIONS = [
  { value: PLAN_TYPES.SAT_SUITE, label: 'Human Risk Management' },
  { value: PLAN_TYPES.CORE, label: 'Essential Protect (Core)' },
  { value: PLAN_TYPES.IRONSCALES_PROTECT, label: 'IRONSCALES Protect' },
  { value: PLAN_TYPES.EMAIL_ESSENTIALS, label: 'Email Essentials' },
  { value: PLAN_TYPES.EMAIL_PROTECT, label: 'Email Protect' },
  { value: PLAN_TYPES.EMAIL_PROTECT_VAR, label: 'Email Protect' },
  { value: PLAN_TYPES.EMAIL_PROTECT_PRO, label: 'Email Protect Pro' },
  { value: PLAN_TYPES.COMPLETE_PROTECT, label: 'Complete Protect' },
]

export const ADD_TO_TRIAL_EXPIRATION_DATE = 14
export const DEFAULT_EXPIRATION_DATE = new Date('2030-12-31')
// MSP Churn Policy fallback constants (IC-45560) — actual values come from API churnPolicy
export const MIN_CHURN_MONTHS = 1
export const ALERT_MIN_MONTHS = 1
export const ALERT_MAX_MONTHS = 2

export const CHANGE_DMARC_PLAN = `${typeKey}/CHANGE_DMARC_PLAN`

export const DMARC_PLANS = {
  MANAGEMENT: 1,
  PRO: 2,
  PREMIUM: 3,
}

export const DMARC_PLAN_OPTIONS = [
  {
    value: DMARC_PLANS.MANAGEMENT,
    label: 'Core Management',
    description:
      "Everything you need to effectively manage email authentication across your clients' domains",
  },
  {
    value: DMARC_PLANS.PRO,
    label: 'Pro',
    description: 'Includes everything in Core Management plus Hosted DKIM and real-time alerting',
  },
  {
    value: DMARC_PLANS.PREMIUM,
    label: 'Premium',
    description:
      'Advanced protection with Threat Intelligence, PGP Encryption and Detailed Reports',
    showOnlyIfSelected: true,
  },
]

export const DMARC_MANAGEMENT_ADDON_NAME = 'DMARC Management'

export const CHANGE_ENCRYPTION_LEVEL = `${typeKey}/CHANGE_ENCRYPTION_LEVEL`

export const ENCRYPTION_LEVELS = {
  ENCRYPTION: 1,
  DLP: 2,
}

export const EMAIL_ENCRYPTION_ADDON_NAME = 'Email Encryption'

export const EMAIL_DLP_ADDON_NAME = 'Email Encryption + Email DLP'

export const ENCRYPTION_LEVEL_OPTIONS = [
  {
    value: ENCRYPTION_LEVELS.ENCRYPTION,
    label: 'Elective Encryption',
    description:
      'Give senders manual control. Encrypt outbound emails manually or by Outlook add in',
  },
  {
    value: ENCRYPTION_LEVELS.DLP,
    label: EMAIL_DLP_ADDON_NAME,
    description:
      'Outbound email scanned and sensitive content automatically encrypted by admin-determined policies',
  },
]
